function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  stroke: "#495A95"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.4312 27.6405C23.6764 27.6405 27.6408 21.6211 27.6408 16.4101C27.6408 16.2407 27.6408 16.0714 27.6332 15.902C28.4015 15.3478 29.0699 14.6474 29.6 13.8545C28.8932 14.1701 28.1326 14.378 27.3335 14.478C28.1479 13.9931 28.7703 13.2157 29.0699 12.292C28.3093 12.7461 27.4641 13.0694 26.5652 13.2464C25.843 12.4767 24.8212 11.9995 23.6917 11.9995C21.5174 11.9995 19.7503 13.7699 19.7503 15.9482C19.7503 16.2561 19.7887 16.5563 19.8502 16.8488C16.5772 16.6872 13.673 15.1092 11.7292 12.723C11.3911 13.308 11.1991 13.9854 11.1991 14.7089C11.1991 16.0791 11.8982 17.2875 12.9508 17.9957C12.3054 17.9726 11.6985 17.7956 11.1683 17.5031C11.1683 17.5185 11.1683 17.5339 11.1683 17.557C11.1683 19.4659 12.5282 21.0669 14.3261 21.4287C13.9957 21.5211 13.65 21.5673 13.2889 21.5673C13.0353 21.5673 12.7895 21.5442 12.5513 21.498C13.0507 23.0682 14.5105 24.2074 16.2315 24.2382C14.8793 25.3005 13.1813 25.9316 11.3374 25.9316C11.0224 25.9316 10.7073 25.9163 10.4 25.8778C12.1364 26.9862 14.2108 27.6405 16.4312 27.6405",
  fill: "#495A95"
});

var SvgIconTwitterOutline = function SvgIconTwitterOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTwitterOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_twitter_outline.ea073dc5.svg";
export { ForwardRef as ReactComponent };